export class AdInfo {
    id?: number;
    name: string = "";
    description?: string = "";
    adImageUrl: string = "";
    adImageHash?: string = "";
    destinationUrl: string = "";
}
